import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { uniqueId } from 'lodash';
const StyledTableCell = styled.div `
    display: flex;
    flex-direction: column;
    flex-basis: 50%;
    margin-top: 15px;
    padding-right: 10px;
    color: ${props => props.theme.primary.base};

    &:last-child {
        padding-right: 0;

        svg {
            margin-right: 10px;
            fill: ${props => props.theme.primary.base};
        }
    }

    &:nth-child(1),
    &:nth-child(2) {
        margin-top: 0;
    }

    ${props => props.type === 'button' &&
    css `
            @media only screen and (max-width: 991px) {
                position: absolute;
                right: -10px;
                bottom: -10px;
            }
        `};

    @media only screen and (min-width: 992px) {
        margin-top: 0;
        flex: 1;
        max-width: ${props => props.maxWidth || 'none'};
        text-align: ${props => props.align};
        display: flex;
        justify-content: ${props => {
    switch (props.align) {
        case 'center':
            return props.align;
        case 'right':
            return 'flex-end';
        case 'left':
        default:
            return 'flex-start';
    }
}};
    }
`;
const Value = styled.span `
    display: block;
    color: ${props => props.theme.primary.base};
    font-size: 15px;
    font-weight: 400;
`;
const TableCell = ({ label, value, children, maxWidth, align, type, className, title, }) => {
    const id = useMemo(uniqueId, []);
    return (_jsxs(StyledTableCell, { maxWidth: maxWidth, align: align, type: type, className: className, children: [value && (_jsx(Value, { "aria-labelledby": label ? id : undefined, className: "table-cell__value", title: title, children: value })), children] }));
};
export default TableCell;
